import React from 'react';

import { useIntl } from 'react-intl';

import { INPUT_METHOD } from '@atlaskit/editor-common/analytics/types/enums';
import { toolbarInsertBlockMessages } from '@atlaskit/editor-common/messages/insert-block';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { BlockMenuItemComponentProps } from '@atlaskit/editor-plugin-block-menu/blockMenuPluginType';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar/toolbar-dropdown-item';
import ExpandElementIcon from '@atlaskit/icon-lab/core/expand-element';

import type { ExpandPlugin } from '../types';

type Props = {
	api: ExtractInjectionAPI<ExpandPlugin> | undefined;
	isSuggested?: boolean;
};

const NODE_NAME = 'expand';

const ExpandBlockMenuItem = ({ api, isSuggested }: Props) => {
	const { formatMessage } = useIntl();

	const handleClick = (event: React.MouseEvent | React.KeyboardEvent) => {
		const triggeredFrom =
			event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0
				? INPUT_METHOD.KEYBOARD
				: INPUT_METHOD.MOUSE;
		const inputMethod = INPUT_METHOD.BLOCK_MENU;

		api?.core.actions.execute(({ tr }) => {
			const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.expand, {
				inputMethod,
				isSuggested,
				triggeredFrom,
				targetTypeName: NODE_NAME,
			});
			return command ? command({ tr }) : null;
		});
	};

	return (
		<ToolbarDropdownItem
			onClick={handleClick}
			elemBefore={<ExpandElementIcon label="" size="small" />}
		>
			{formatMessage(toolbarInsertBlockMessages.expand)}
		</ToolbarDropdownItem>
	);
};

export const createExpandBlockMenuItem = (api: ExtractInjectionAPI<ExpandPlugin> | undefined) => {
	return ({ isSuggested }: BlockMenuItemComponentProps = {}): React.JSX.Element => (
		<ExpandBlockMenuItem api={api} isSuggested={isSuggested} />
	);
};
